const actions = {
    GET_ALL_JOBBOARDS: 'GET_ALL_JOBBOARDS',

    jobboards: (data) => {
        return {
            type: actions.GET_ALL_JOBBOARDS,
            data,
        };
    },
};

export default actions;
